// extracted by mini-css-extract-plugin
module.exports = {"page":"recipe-results_page__8xKi_","noMinHeight":"recipe-results_noMinHeight__8LzlK","paginationContainer":"recipe-results_paginationContainer__Zxa4l"};